import { render } from "./Index.vue?vue&type=template&id=17c290af&scoped=true"
import script from "./Index.vue?vue&type=script&lang=ts"
export * from "./Index.vue?vue&type=script&lang=ts"

import "./Index.vue?vue&type=style&index=0&id=17c290af&lang=scss"
import "./Index.vue?vue&type=style&index=1&id=17c290af&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-17c290af"

export default script